"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contactPreferenceProps = exports.contactPreferencePageProps = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _contactPreferences = require("../../helpers/contactPreferences.helpers");
var _queryString = _interopRequireDefault(require("query-string"));
var contactPreferenceProps = exports.contactPreferenceProps = process.env.IS_BROWSER ? {
  email: (0, _contactPreferences.parseQueryParam)(window.location.search, 'email')
} : {};
var contactPreferencePageProps = exports.contactPreferencePageProps = process.env.IS_BROWSER ? {
  jobid: (0, _get2["default"])(_queryString["default"].parse(window.location.search), 'jobid')
} : {};


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/analytics/contactPreferenceProps.js
// module id = 4301
// module chunks = 9